import React, { lazy } from 'react';

const TermsServiceGoogle = lazy(() => import('./TermsServiceGoogle'));

export { TermsServiceGoogle }